/**
 * Single-question row with Yes / No / Unsure three-button toggle group.
 * Controlled component — answer + onAnswer come from parent (RoomPage).
 */

import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';
import type { AnswerValue } from '../types/homeAudit.types';

type QuestionItemProps = {
  questionId: string;
  text: string;
  answer: AnswerValue | undefined;
  onAnswer: (questionId: string, answer: AnswerValue) => void;
};

const OPTIONS: Array<{ value: AnswerValue; label: string }> = [
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
  { value: 'UNSURE', label: 'Unsure' },
];

export const QuestionItem = ({
  questionId,
  text,
  answer,
  onAnswer,
}: QuestionItemProps) => {
  return (
    <div className="space-y-3" data-testid={`question-${questionId}`}>
      <p className="text-base font-medium">{text}</p>
      <div className="flex gap-2">
        {OPTIONS.map(({ value, label }) => {
          const isActive = answer === value;
          return (
            <Button
              key={value}
              type="button"
              variant="outline"
              className={cn(
                'h-11 flex-1 sm:flex-none sm:min-w-[96px]',
                isActive && 'bg-[#026857]/10 border-[#026857] text-[#026857] font-medium',
              )}
              onClick={() => onAnswer(questionId, value)}
              data-active={isActive}
              data-answer={value}
            >
              {label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
